import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail.data.html.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (!newMediaGallery || !currentMediaGallery) return;

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(newMediaGallery);

      // Réactive les boutons AR (data-shopify-xr) présents dans le nouveau HTML
      window.ShopifyXR?.setupXRElements();
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}
if (window.location.hash === '#voir-video') {
  let attempts = 0;

  const videoTimer = window.setInterval(() => {
    attempts += 1;

    const gallery = document.querySelector(
      'product-media-gallery'
    );
    const carousel = gallery?.querySelector('slider-component');
    const slides = Array.from(
      carousel?.querySelectorAll(
        '[data-ref="main-slider"] .product-media-gallery__media'
      ) || []
    );

    const videoIndex = slides.findIndex((slide) =>
      slide.querySelector('deferred-media, video, iframe')
    );

    if (carousel?.slider && videoIndex >= 0) {
      window.clearInterval(videoTimer);
      carousel.slider.go(videoIndex);
      gallery.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    if (attempts >= 50) {
      window.clearInterval(videoTimer);
    }
  }, 200);
}
